<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 10/10/2020
  -->


<template>
	<QwoachDialogLayout>
		<div>
			<div>
				Logged:
					<TimeEntryInput v-model="durationMs"
									placeholder="0:00"
									class="duration-width"
									:input-debounce-delay="1000"
									@change="onDurationChanged">
					</TimeEntryInput>

				on
				<el-date-picker
					v-model="dateStart"
					class="pointer no-select show-prefix-icon"
					type="date"
					style="width: 7.5rem"
					:clearable="false"
					format="MMM dd, yyyy"
					placeholder="Pick a day"
				@change="onDateChanged">
				</el-date-picker>
				<i class="fontello icon-down-dir text-muted"/>
			</div>

			<div class="mt-2">
				<qw-input class="w-100"
						  :multiline="true"
						  v-model="description"
						  placeholder="Add description"
						  :input-debounce-delay="1000"
						  @input="onDescriptionChanged">

				</qw-input>
			</div>

		</div>
		<template #footer>
			<div class="row dialog-footer mx-0 mt-5" style="text-align: left">
				<div class="layout-spacer"></div>
				<el-button size="small" @click="onCancel">Cancel</el-button>
				<el-button size="small" type="primary" @click="onOk()">Save</el-button>
			</div>
		</template>

	</QwoachDialogLayout>
</template>

<script>

	import BillingData from "@shared/Billing/BillingData";
	import BillingItem from "@shared/Billing/BillingItem";

	import TimeEntryInput from "../TimeEntryInput"
	import QwoachDialogLayout from "@/core/components/Dialogs/QwoachDialog/QwoachDialogLayout.vue";
	import QwoachDialog from "@/core/components/Dialogs/QwoachDialog/QwoachDialog.vue";
	import QwInput from "@/core/components/Controls/QwInput.vue";

	/* eslint-disable vue/no-mutating-props */

	export default {
		name: "PaidConfirmDialog",
		extends: QwoachDialog,
		components: {
			QwInput,
			QwoachDialogLayout,
			TimeEntryInput
		},
		props: {
			billingData: BillingData,
			billingItem: BillingItem
		},
		data: () => ({
			durationMs: 0,
			dateStart: new Date(),
			description: ""
		}),

		created() {

		},
		mounted() {
			let startDateMs = this.billingItem.startDateMs || new Date().getTime()
			this.durationMs = this.billingItem.durationMs
			this.dateStart = new Date(startDateMs)
			this.description = this.billingItem.additionalNote
		},

		methods: {

			onDescriptionChanged(){
				this.$analyticManager.trackEvent("Description changed", this.analyticsPropsMethod())
			},
			onDurationChanged(){
				this.$analyticManager.trackEvent("Logged time changed", this.analyticsPropsMethod())
			},
			onDateChanged(){
				this.$analyticManager.trackEvent("Logged date changed", this.analyticsPropsMethod())
			},

			createDataItem() {
				this.billingItem.durationMs = this.durationMs
				this.billingItem.startDateMs = this.dateStart.getTime()
				// if(this.billingItem.name !== this.description){
				// 	this.billingItem.isNameSetManually = true
				// }
				this.billingItem.additionalNote = this.description
				return this.billingItem
			},

		},

		computed: {

			dialogTitle(){
				return "Edit time entry"
			}
		}


	}
</script>

<style>
	.spacer {
		width: 25px;
		display: inline-block
	}
</style>
